export default __webpack_public_path__ + "static/media/iconeMeusProvedoresMaior.40de6b4f.png";